import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import GlobalService from "@/services/global-service";
import { useAppNav } from "@/composables/useAppNav";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBottomNav',
  setup(__props) {

const { showBottomNav, routeName, visibleItems } = useAppNav();

async function go(name: string): Promise<void> {
  await GlobalService.router().routeTo(name);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!

  return (_unref(showBottomNav))
    ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
        key: 0,
        app: "",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleItems), (item) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: item.route,
              value: item.route,
              active: _unref(routeName) === item.route,
              ripple: true,
              stacked: "",
              onClick: ($event: any) => (go(item.route))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: item.icon
                }, null, 8, ["icon"]),
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["value", "active", "onClick"]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})